<template>
  <span class='timer'>{{ formattedTime }}</span>
</template>

<script>
export default {
  props: {
    time: {
      type: Number,
      required: true
    }
  },
  computed: {
    // Format seconds into HH : MM : SS display
    formattedTime () {
      let hours = Math.floor(this.time / 3600)
      let minutes = Math.floor((this.time % 3600) / 60)
      let seconds = this.time % 60
      if (hours < 10) hours = '0' + hours
      if (minutes < 10) minutes = '0' + minutes
      if (seconds < 10) seconds = '0' + seconds
      return `${hours} : ${minutes} : ${seconds}`
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/Countdown.vue